export enum USER_ROLE {
  ADMIN = 'ADMIN',
  TECHNICIAN = 'TECHNICIAN',
  USER = 'USER'
}

export type User = {
  id: number,
  email: string,
  first_name: string,
  last_name: string,
  role: USER_ROLE
}